export const SAMPLE_DEV_NOTICE_ROLE_FIELDS = [
  { key: 'design_user', label: '设计师' },
  { key: 'design_assistant_name', label: '设计助理' },
  { key: 'car_master_user', label: '车版师' },
  { key: 'pattern_maker_user', label: '纸样师' },
] as const;

export const hasSampleDevNoticeRoleValue = (value: unknown) => {
  if (value == null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  return String(value).trim() !== '';
};

/** 消息卡片只展示有值的岗位，空的设计师/助理/车版师/纸样师整项不渲染 */
export const getVisibleSampleDevNoticeRoleFields = (content?: Record<string, unknown> | null) =>
  SAMPLE_DEV_NOTICE_ROLE_FIELDS.filter((field) =>
    hasSampleDevNoticeRoleValue(content?.[field.key]),
  );

export const getSampleDevNoticeRoleRows = (content?: Record<string, unknown> | null) => {
  const fields = getVisibleSampleDevNoticeRoleFields(content);
  const rows: (typeof fields)[] = [];
  for (let i = 0; i < fields.length; i += 2) {
    rows.push(fields.slice(i, i + 2));
  }
  return rows;
};
